// A quiet editorial strip — the brand manifesto, set like a museum plate.
export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-parchment py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center reveal">
        <p className="text-overline text-gold mb-8">The ARVI Manifesto</p>
        <blockquote className="font-display text-2xl md:text-[2.25rem] lg:text-[2.75rem] leading-[1.35] text-maroon italic">
          “True art is not created in a moment —
          <br className="hidden md:block" />
          it is built over a lifetime. ARVI exists to honour
          <br className="hidden md:block" />
          the artist who mastered her craft long before the world noticed.”
        </blockquote>
        <div className="mt-10 flex items-center justify-center gap-4">
          <span className="h-px w-10 bg-gold" />
          <span className="text-overline text-maroon/70">A promise, from a son</span>
          <span className="h-px w-10 bg-gold" />
        </div>
      </div>

      {/* Marquee of brand values */}
      <div className="mt-20 border-y border-[hsl(var(--gold)/0.35)] py-6 overflow-hidden">
        <div className="marquee">
          {Array.from({ length: 2 }).map((_, dupIdx) => (
            <div key={dupIdx} className="flex gap-14 shrink-0 pr-14">
              {[
                "Legacy & Heritage",
                "Handcrafted Excellence",
                "Authenticity & Truth",
                "Emotional Connection",
                "Art as Respect",
                "Preservation of Indian Art",
              ].map((v, i) => (
                <span
                  key={`${dupIdx}-${i}`}
                  className="font-display italic text-xl md:text-2xl text-maroon/70 flex items-center gap-14"
                >
                  {v}
                  <span className="text-gold">✦</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
